/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircuitDiode = createReactComponent("circuit-diode", "IconCircuitDiode", [
  ["path", { d: "M22 12h-6", key: "svg-0" }],
  ["path", { d: "M2 12h6", key: "svg-1" }],
  ["path", { d: "M8 7l8 5l-8 5z", key: "svg-2" }],
  ["path", { d: "M16 7v10", key: "svg-3" }]
]);

export { IconCircuitDiode as default };
//# sourceMappingURL=IconCircuitDiode.js.map
